import React from 'react';
import { MdClear } from 'react-icons/md';
import '../Filters/Filters.scss';

const SearchFilter = ({
  label = 'Search',
  value,
  onChange,
  placeholder = 'Search',
  disabled = false,
}) => {
  return (
    <div className="filter-control">
      {label && <label className="filter-label">{label}</label>}
      <div className="search-input-wrapper">
        <input
          type="text"
          className="filter-input"
          disabled={disabled}
          placeholder={placeholder}
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
        {value && !disabled && (
          <button
            type="button"
            className="search-clear-btn"
            onClick={() => onChange && onChange('')}
            title="Clear search"
          >
            <MdClear size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchFilter;

